import React from 'react';
import TopBar from '../../components/layout/TopBar';
import Footer from '../../components/layout/Footer';
import useServiceDetailsModel from '../../hooks/useServiceDetailsModel';
import { DEMAND_HIGHLIGHTED_SERVICES } from '../../config/servicePricingConfig';
import {
  ServiceDetailsHeader,
  ServiceDetailsMainSection,
  ServiceFaqSection,
  ServiceReviewsSection
} from './ServiceDetailsSections';

const ServiceDetailsPage = ({ onNavigate, service }) => {
  const {
    serviceData,
    parentPage,
    parentLabel,
    servicePricingConfig,
    schedulePricing,
    jaapPricing,
    anusthanPricing,
    selectedDurationDays,
    setSelectedDurationDays,
    selectedPanditCount,
    setSelectedPanditCount,
    panditCountOptions,
    selectedJaapCount,
    setSelectedJaapCount,
    selectedJaapOption,
    selectedAnusthanType,
    setSelectedAnusthanType,
    selectedAnusthanOption,
    anusthanPanditOptions,
    detailedInfo,
    serviceExecutionDetails,
    serviceProfile,
    selectedPackage,
    setSelectedPackage,
    dakshinaAmount,
    setDakshinaAmount,
    selectedAddOns,
    handleAddOnToggle,
    addOnServices,
    formatPrice,
    calculateTotalPrice,
    pricingBreakdown,
    frequentSuggestion,
    suggestedPandit,
    rankedProviders,
    catalogLoading,
    availabilityLoading,
    cityFilter,
    setCityFilter,
    onlyAvailable,
    setOnlyAvailable,
    sortBy,
    setSortBy,
    packages,
    serviceReviews,
    serviceFaqs,
    handleBookNow,
    handleBookWithPandit,
    handleViewPanditProfile
  } = useServiceDetailsModel({ service, onNavigate });

  const handleNavigateDemandService = (demandService) => {
    if (!onNavigate) {
      return;
    }

    onNavigate('service-details', {
      service: {
        ...demandService,
        name: demandService.title,
        servicePage: parentPage || 'home'
      }
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* TopBar */}
      <TopBar 
        onUserClick={() => onNavigate && onNavigate('login')}
        onLogoClick={() => onNavigate && onNavigate('home')}
      />

      <ServiceDetailsHeader
        onNavigate={onNavigate}
        serviceData={serviceData}
        parentPage={parentPage}
        parentLabel={parentLabel}
      />
      <ServiceDetailsMainSection
        serviceData={serviceData}
        serviceProfile={serviceProfile}
        servicePricingConfig={servicePricingConfig}
        schedulePricing={schedulePricing}
        jaapPricing={jaapPricing}
        anusthanPricing={anusthanPricing}
        selectedDurationDays={selectedDurationDays}
        setSelectedDurationDays={setSelectedDurationDays}
        selectedPanditCount={selectedPanditCount}
        setSelectedPanditCount={setSelectedPanditCount}
        panditCountOptions={panditCountOptions}
        selectedJaapCount={selectedJaapCount}
        setSelectedJaapCount={setSelectedJaapCount}
        selectedJaapOption={selectedJaapOption}
        selectedAnusthanType={selectedAnusthanType}
        setSelectedAnusthanType={setSelectedAnusthanType}
        selectedAnusthanOption={selectedAnusthanOption}
        anusthanPanditOptions={anusthanPanditOptions}
        detailedInfo={detailedInfo}
        demandHighlightedServices={DEMAND_HIGHLIGHTED_SERVICES}
        onNavigateDemandService={handleNavigateDemandService}
        serviceExecutionDetails={serviceExecutionDetails}
        packages={packages}
        selectedPackage={selectedPackage}
        setSelectedPackage={setSelectedPackage}
        dakshinaAmount={dakshinaAmount}
        setDakshinaAmount={setDakshinaAmount}
        addOnServices={addOnServices}
        selectedAddOns={selectedAddOns}
        handleAddOnToggle={handleAddOnToggle}
        formatPrice={formatPrice}
        calculateTotalPrice={calculateTotalPrice}
        pricingBreakdown={pricingBreakdown}
        handleBookNow={handleBookNow}
        frequentSuggestion={frequentSuggestion}
        suggestedPandit={suggestedPandit}
        handleBookWithPandit={handleBookWithPandit}
        cityFilter={cityFilter}
        setCityFilter={setCityFilter}
        sortBy={sortBy}
        setSortBy={setSortBy}
        onlyAvailable={onlyAvailable}
        setOnlyAvailable={setOnlyAvailable}
        catalogLoading={catalogLoading}
        availabilityLoading={availabilityLoading}
        rankedProviders={rankedProviders}
        handleViewPanditProfile={handleViewPanditProfile}
      />
      <ServiceReviewsSection serviceReviews={serviceReviews} />
      <ServiceFaqSection serviceFaqs={serviceFaqs} />

      {/* Footer */}
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default ServiceDetailsPage;

